import { getLocalizedString } from "owa-datetime-formatters-core";
import { localizedFormatter } from "./localizedFormatter";
import { getShortHourFormat } from "./formatShortHour";
import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";

/**
 * Gets the short time format, from the user's settings.
 * Follows the same rules as getShortHour, but appends the
 * language's time separator and minutes to the hour.
 */
export function getShortTimeFormat(dateFormat: string, timeFormat: string): string {
    const shortHourFormat = getShortHourFormat(dateFormat, timeFormat);
    return shortHourFormat.replace(/(H+|h+)/, "$1" + getLocalizedString("timeSeparator") + "mm");
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
localizedFormatter(getShortTimeFormat);
export default defaultExport;
